<section fxLayout="column" fxFlexAlign="stretch">
  <div fxFlexAlign="center">
    <p>{{title}}</p>
  </div>
  <mat-card *ngIf="!startTest && !questionPool" class="textAlignCenter">
    Loading ...
  </mat-card>
  <mat-card *ngIf="!startTest && questionPool" class="textAlignCenter md-line-height">
    <button mat-raised-button color="basic" class="question-selector-button margin-right-10" routerLink="/">
      < Home
    </button>
    <button mat-raised-button color="basic" (click)="startWithRandom(numberOfRandomQuestions)"
            class="question-selector-button margin-right-10">
      Starte mit {{numberOfRandomQuestions}} zufälligen Fragen
    </button>
    <button mat-raised-button color="basic" (click)="startWithAll()" class="question-selector-button">
      Starte mit allen verfügbaren Fragen
    </button>
  </mat-card>
  <div *ngIf="startTest && contributor" fxFlexAlign="center" style="width: 60%">
    <span *ngIf="!contributorUrl" style="float: right">Contributor: {{contributor}}</span>
    <span *ngIf="contributorUrl" style="float: right">Contributor: <a href="{{contributorUrl}}">{{contributor}}</a></span>
  </div>
  <mat-card *ngIf="startTest">
    <div *ngFor="let question of questions; let i = index">
      <mat-card-content>
        <h3>{{question.name}}</h3>

        <pre *ngIf="question.description">{{question.description}}</pre>

        <ul *ngIf="question.type == 'checkbox'">
          <li *ngFor="let answer of question.answers; let j = index" class="example-margin">
            <mat-checkbox [(ngModel)]="checkboxAnswers[i][j]"
                          [style]="showSolution ? (checkCheckboxSolution(questions[i], answer, i, j) ? 'color: green' : 'color: red') : ''">
              {{answer.text}}
            </mat-checkbox>
          </li>
        </ul>
        <mat-radio-group *ngIf="question.type == 'radio'" [(ngModel)]="radioAnswers[i]">
          <mat-radio-button *ngFor="let answer of question.answers; let j = index" [value]="answer.text"
                            [style]="showSolution ? (checkRadioSolution(questions[i], answer, i) ? 'color: green' : 'color: red') : ''">
            {{answer.text}}
          </mat-radio-button>
        </mat-radio-group>
        <div *ngIf="question.type == 'dropList' && (question.useDisabled === undefined || !question.useDisabled)" cdkDropList cdkDropListOrientation="{{question.orientation}}"
             class="dropList {{question.orientation}}" (cdkDropListDropped)="drop(i, $event, false)">
          <div class="dropListBox"
               *ngFor="let answer of dropListSource[this.getDropListSourcePosition(i)].answers; let j = index" cdkDrag
               [style]="showSolution ? (checkDropListSolution(questions[i], answer, i, j) ? 'color: green' : 'color: red') : ''">{{answer.text}}</div>
        </div>
        <div *ngIf="question.type == 'dropList' && question.useDisabled !== undefined && question.useDisabled">
          <div cdkDropList cdkDropListOrientation="{{question.orientation}}"
               class="dropList {{question.orientation}} double dropListEnabled" (cdkDropListDropped)="drop(i, $event, false)"
               #enabledDropList="cdkDropList" [cdkDropListConnectedTo]="[disabledDropList]">
            <div class="dropListBox"
                 *ngFor="let answer of dropListSource[this.getDropListSourcePosition(i)].answers; let j = index" cdkDrag
                 [style]="showSolution ? (checkDropListSolution(questions[i], answer, i, j, true) ? 'color: green' : 'color: red') : ''">{{answer.text}}</div>
          </div>
          <div cdkDropList cdkDropListOrientation="{{question.orientation}}"
               class="dropList {{question.orientation}} double dropListDisabled" (cdkDropListDropped)="drop(i, $event, true)"
               #disabledDropList="cdkDropList" [cdkDropListConnectedTo]="[enabledDropList]">
            <div class="dropListBox"
                 *ngFor="let answer of dropListSource[this.getDropListSourcePosition(i)].disabledAnswers; let j = index" cdkDrag
                 [style]="showSolution ? (!answer.value ? 'color: green' : 'color: red') : ''">{{answer.text}}</div>
          </div>
        </div>
      </mat-card-content>
      <hr *ngIf="i < questions.length-1" class="mat-card-hr">
    </div>
  </mat-card>

  <mat-card class="margin-top-20" *ngIf="startTest">
    <span style="float: left">
      <button mat-raised-button color="primary" (click)="solve()" class="abgeben-button">
        Prüfen
      </button>
      <button mat-raised-button color="basic" (click)="reset()" class="abgeben-button margin-left-10"
              *ngIf="showSolution">
        Reset
      </button>
      <button mat-raised-button color="basic" class="question-selector-button margin-left-10" routerLink="/"
              *ngIf="showSolution">
      < Home
    </button>
    </span>
    <span style="float: right; margin-left: 10px; margin-top: 10px;" *ngIf="showSolution">
      {{rightAnswers}} von {{possibleAnswersCounter}} Antworten sind richtig!
    </span>
  </mat-card>

</section>
